import React from 'react';
import './AboutCategory.scss';

const AboutCategory = props => {
  const { categoryData, filterFail } = props;
  return (
    <div
      className={
        filterFail ? 'text-black category-footer full-width' : 'text-black category-footer'
      }
    >
      <div
        dangerouslySetInnerHTML={{ __html: categoryData.result.description }}
        className="border-top"
      ></div>
    </div>
  );
};

export default AboutCategory;
